module.exports = __webpack_public_path__ + "static/media/WeighRite_Logo_Dark.da2dfe5b.png";